module.exports = __webpack_public_path__ + "static/img/dCT1.d08ae64a.png";